export const EN_UI_LITERALS = {
"Back to Home": "Back to Home",
  "Jetzt aktualisieren": "Refresh now",
  "Die Unternehmensstruktur konnte nicht aktualisiert werden. Die angezeigten Einträge sind möglicherweise nicht aktuell.": "The company structure could not be refreshed. The displayed entries may be out of date.",
  "POS wurde angelegt. Die Unternehmensstruktur konnte nicht aktualisiert werden.": "The POS was created. The company structure could not be refreshed.",
  "Letzte Archivierungen": "Recent archival jobs",
  "Dateien": "Files",
  "Archiviert": "Archived",
  "Keine Archivierungen verfügbar": "No archival jobs available",
  "Der Archivierungsstatus konnte nicht aktualisiert werden.": "The archival status could not be refreshed.",
  "Der Exportstatus konnte nicht aktualisiert werden.": "The export status could not be refreshed.",
  "Archivierungen aus Web-Uploads und POS-Übermittlungen Ihrer Organisation.": "Archival of web uploads and POS submissions for your organization.",
  "Archivierungen aus Ihren Web-Uploads.": "Archival of your web uploads.",
"(+ Erste Betriebsstätte anlegen)": "(+ Create first site)",
"(+ Erste POS anlegen)": "(+ Create first POS)",
"(+ Unternehmen in der Unternehmensstruktur hinzufügen)": "(+ Add company to company structure)",
"+ Betriebsstätte anlegen": "+ Create site",
"+ Erste Betriebsstätte anlegen": "+ Create first site",
"+ Erste POS anlegen": "+ Create first POS",
"+ Erstes Unternehmen anlegen": "+ Create first company",
"+ POS anlegen": "+ Create POS",
"0 B": "0 B",
"0.00 MB": "0.00 MB",
"Abbrechen": "Cancel",
"Leeren": "Clear",
"Heute": "Today",
"Akzeptieren": "Accept",
"Bitte akzeptieren Sie die Geschäftsbedingungen.": "Please accept the Terms & Conditions.",
"Bitte akzeptieren Sie die Geschäftsbedingungen, um EleFANT weiter zu verwenden.": "Please accept the Terms & Conditions to continue using EleFANT.",
"Die Zustimmung konnte nicht gespeichert werden.": "The acceptance could not be saved.",
"Das Konto wurde noch nicht aktiviert. Bitte fordern Sie einen neuen Aktivierungslink bei Ihrem Administrator an.": "This account has not been activated yet. Please request a new activation link from your administrator.",
"Für dieses Unternehmen sind keine Betriebsstätten verfügbar. Wählen Sie „Gesamtes Unternehmen“.": "No sites are available for this company. Select ‘Entire company’.",
"Für dieses Unternehmen sind keine POS verfügbar. Wählen Sie „Gesamtes Unternehmen“.": "No POS are available for this company. Select ‘Entire company’.",
"Für dieses Unternehmen sind keine POS verfügbar. Wählen Sie „Ausgewählte Betriebsstätten“ oder „Gesamtes Unternehmen“.": "No POS are available for this company. Select ‘Selected sites’ or ‘Entire company’.",
"Zustimmung wird gespeichert…": "Saving acceptance…",
"Aktion bestätigen": "Confirm action",
"Administration": "Administration",
"Akteur": "Actor",
"Aktion": "Action",
"Aktion erforderlich: Unternehmen wählen.": "Action required: select a company.",
"Aktion erforderlich: mindestens eine Betriebsstätte wählen.": "Action required: select at least one site.",
"Aktion erforderlich: POS wählen.": "Action required: select a POS.",
"Aktion erforderlich: Zeitraum vollständig wählen (Von/Bis).": "Action required: select a complete period (from/to).",
"Aktion fehlgeschlagen.": "Action failed.",
"Aktionen": "Actions",
"Auswahl": "Select",
"Benachrichtigung schließen": "Dismiss notification",
"Betriebsstätte (optional)": "Site (optional)",
"Betriebsstätten (optional)": "Sites (optional)",
"Ausstehend": "Pending",
"Aktiv": "Active",
"Aktivieren": "Activate",
"Aktivierte Elemente": "Active items",
"Aktualisieren": "Refresh",
"Aktueller Export": "Current export",
"Alle hochgeladenen Dateien und Auswahlen werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.": "All uploaded files and selections will be removed. This action cannot be undone.",
"Andere": "Other",
"Anfrage erstellen": "Create request",
"Anfrage offen": "Open request",
"Anfrage ausstehend": "Request pending",
"Anfrage ausblenden": "Hide request submission",
"Anfrage stellen": "Submit request",
"Anfrager": "Requester",
"Anlegen": "Create",
"Anlegen ausblenden": "Hide create",
"Organisationsanlage ausblenden": "Hide organization creation",
"Reseller-Anlage ausblenden": "Hide reseller creation",
"Einladung erneut senden": "Resend invitation",
"Einladung konnte nicht erneut gesendet werden.": "Invitation could not be resent.",
"Einladung wurde erneut gesendet.": "Invitation was resent.",
"Reseller konnte nicht angelegt werden.": "Reseller could not be created.",
"Anmeldung…": "Signing in…",
"Ansprechpartner": "Contact person",
"Anzahl Elemente": "Number of items",
"API-Key Aktualisierung": "API key update",
"API-Key Freigabe": "API key approval",
"API-Key Verwaltung": "API key management",
"API-Key für": "API key for",
"API-Key konnte nicht kopiert werden.": "API key could not be copied.",
"API-Key kopieren": "Copy API key",
"API-Key kopiert": "API key copied",
"Onboarding-Code konnte nicht kopiert werden.": "Onboarding code could not be copied.",
"Onboarding-Code konnte nicht erzeugt werden.": "Onboarding code could not be generated.",
"Mandant wurde gelöscht.": "Tenant has been deleted.",
"Keine Berechtigung, einen Onboarding-Code zu erzeugen.": "You do not have permission to generate an onboarding code.",
"Bitte erneut anmelden.": "Please sign in again.",
"Ein Onboarding-Code erlaubt es einer oder mehreren Kassen, sich automatisch zu registrieren und jeweils einen eigenen API-Key anzufordern. Ein API-Key ist genau einer Kasse zugeordnet. Er ist das Geheimnis, mit dem sich die Kasse gegenüber dem Service identifiziert, und darf nicht zwischen mehreren Kassen geteilt werden. Der Onboarding-Code darf dagegen von mehreren Kassen verwendet werden. Jeder angeforderte API-Key muss anschließend in der API-Key-Verwaltung freigegeben werden.": "An onboarding code allows one or more POS systems to register automatically and request an individual API key for each POS. An API key belongs to exactly one POS. It is the secret used by that POS to identify itself to the service and must not be shared between multiple POS systems. The onboarding code, however, may be used by multiple POS systems. Every requested API key must subsequently be approved in API key management.",
"Onboarding-Codes sind zeitlich unbegrenzt gültig und werden im Portal nur einmal angezeigt. Wenn Sie einen Code verlieren, erzeugen Sie einen neuen; bereits erzeugte Codes bleiben weiterhin gültig.": "Onboarding codes do not expire and are shown only once in the portal. If you lose a code, generate a new one; previously generated codes remain valid.",
"Onboarding-Code erzeugen": "Generate onboarding code",
"Weiteren Onboarding-Code erzeugen": "Generate another onboarding code",
"Abgelaufen": "Expired",
"Fehlgeschlagen": "Failed",
"In Bearbeitung": "Processing",
"Erzeugt…": "Generating…",
"Onboarding-Code": "Onboarding code",
"Onboarding-Code kopieren": "Copy onboarding code",
"Onboarding-Code kopiert": "Onboarding code copied",
"Kopieren": "Copy",
"Kopiert": "Copied",
"Gültig bis": "Valid until",
"Verfügbar bis": "Available until",
"API-Key Verwaltung ist im Tenant-Admin Kontext verfügbar.": "API key management is available in the tenant admin context.",
"API-Keys": "API keys",
"API-Keys verwalten": "Manage API keys",
"Kassen/POS und API-Keys verwalten": "Manage cash registers/POS and API keys",
"API-Key einrichten": "Now set up the API key",
"API-Key löschen": "Delete key",
"Die POS wurde erfolgreich erstellt. Für den sicheren Upload und die Archivierung von Artefakten benötigt sie einen API-Key.": "The POS was created successfully. It requires an API key to securely upload and archive artifacts.",
"Der API-Key wird nur einmal angezeigt. Kopieren Sie ihn jetzt und bewahren Sie ihn sicher auf. Geben Sie ihn nicht an Dritte weiter und entfernen Sie ihn nach der Einrichtung aus allen temporären Ablagen.": "The API key is shown only once. Copy it now and store it securely. Do not share it with third parties, and remove it from all temporary locations after setup.",
"Archiv": "Archive",
"Archivdaten konnten nicht geladen werden.": "Archive data could not be loaded.",
"Archivierte Elemente werden in diesem Zeitraum beim Export exportiert.": "Archived items in this period are included in the export.",
"Artefakte": "Artifacts",
"Artefaktgruppe": "Artifact group",
"Aufklappen": "Expand",
"Alle aufklappen": "Expand all",
"Alle zuklappen": "Collapse all",
"Bearbeiten": "Edit",
"Betriebsstätte": "Site",
"Ein aktives Unternehmen mit diesem Namen existiert bereits in diesem Land.": "An active company with this name already exists in this country.",
"Eine aktive Betriebsstätte mit diesem Namen existiert bereits in diesem Unternehmen.": "An active site with this name already exists in this company.",
"Betriebsstätten": "Sites",
"Betriebsstätte neu anlegen": "Create new site",
"Betriebsstätten verwalten": "Manage sites",
"Bis": "To",
"Bitte alle Passwortfelder ausfüllen.": "Please fill in all password fields.",
"Bitte E-Mail und Passwort eingeben.": "Please enter email and password.",
"Bitte E-Mail eingeben.": "Please enter your email address.",
"Bitte E-Mail-Adresse des Empfängers eingeben.": "Please enter the recipient's email address.",
"Bitte Passwort eingeben.": "Please enter your password.",
"Bitte neues Passwort eingeben.": "Please enter a new password.",
"Bitte Passwort wiederholen.": "Please repeat your password.",
"Bitte Unternehmensname eingeben.": "Please enter a company name.",
"Bitte Betriebsstätte eingeben.": "Please enter a site name.",
"Bitte ein Land auswählen.": "Please select a country.",
"Bitte alle Pflichtfelder ausfüllen.": "Please fill in all required fields.",
"Bitte ein Unternehmen wählen.": "Please select a company.",
"Bitte eine Datei auswählen.": "Please select a file.",
"Bitte einen Namen für den Passkey angeben.": "Please enter a name for the passkey.",
"Bestätigen": "Confirm",
"Betriebsstätte löschen": "Delete site",
"Bitte mindestens ein Unternehmen wählen.": "Please select at least one company.",
"Bitte eine Bezeichnung für die benutzerdefinierte Artefaktgruppe angeben.": "Please enter a label for the custom artifact group.",
"Bitte mindestens eine Kategorie auswählen.": "Please select at least one category.",
"Bitte neuen Betriebsstättennamen angeben.": "Please enter a new site name.",
"Bitte neuen Unternehmensnamen und Land angeben.": "Please enter a new company name and country.",
"Bitte ein Land mit aktivem Profil wählen.": "Please select a country with an active profile.",
"Bitte ein Unternehmen aus einem Land mit aktivem Profil wählen.": "Please select a company in a country with an active profile.",
"Bitte POS-Seriennummer angeben.": "Please enter a POS serial number.",
"Bitte Unternehmen/Betriebsstätte wählen oder neu anlegen.": "Please select or create a company/site.",
"Bitte wählen": "Please select",
"Bitte Zeitraum vollständig wählen (Von/Bis).": "Please select a complete period (from/to).",
"Bitte zuerst Filter anwenden und Treffer erzeugen.": "Please apply filters first to generate results.",
"Bitte zuerst speichern, damit die neuen Werte aktiv werden.": "Please save first so the new values become active.",
"Changelog": "Changelog",
"Cloud-Upload": "Cloud upload",
"Commit fehlgeschlagen.": "Commit failed.",
"Upload abgelehnt: Das Speicherlimit von 25 GB für diese Betriebsstätte ist erreicht.": "Upload rejected: This site's 25 GB storage limit has been reached.",
"Upload abgelehnt: Das Speicherlimit von 1 GB für unternehmensweite Artefakte dieser Organisation ist erreicht.": "Upload rejected: This organization's 1 GB limit for company-wide artifacts has been reached.",
"Upload abgelehnt: Die ausgewählte Dateigruppe überschreitet die maximale Gesamtgröße.": "Upload rejected: The selected file group exceeds the maximum combined size.",
"Datei": "File",
"Datei hinzufügen": "Add file",
"Datei löschen": "Delete file",
"Datei konnte nicht entfernt werden.": "File could not be removed.",
"Dateiliste": "File list",
"Daten archivieren": "Archive data",
"Datenschutz": "Privacy policy",
"Datum": "Date",
"DE": "DE",
"de-DE": "de-DE",
"Deaktivieren": "Deactivate",
"Deaktiviert": "Inactive",
"Schließen": "Close",
"deleteExport failed:": "deleteExport failed:",
"deleteExport returned 400": "deleteExport returned 400",
"deleteExport returned 404": "deleteExport returned 404",
"Demo Organisation": "Demo organization",
"Der Export löscht die Daten und macht den TSE Speicher wieder frei.": "The export deletes the data and frees TSE storage.",
"Sobald er bereitsteht, kann der Export 7 Tage lang heruntergeladen werden.": "Once ready, the export can be downloaded for 7 days.",
"Export herunterladen": "Download export",
"Der offene Web-Upload enthält Dateien, die noch nicht archiviert sind. Beim Verlassen der aktuellen Sitzung werden diese Dateien und alle Upload-Auswahlen verworfen. Dies kann nicht rückgängig gemacht werden.": "The open Web Upload contains files that have not been archived yet. Leaving the current session will discard these files and all upload selections. This cannot be undone.",
"Di": "Tue",
"Dialog geöffnet": "Dialog opened",
"Dialog schließen": "Close dialog",
"Die Daten sind auf dem Weg ins Archiv. Sie können den Dialog schliessen.": "Data is being archived. You can close the dialog.",
"Diese Details sind für diesen Upload eingefroren. Verwerfen Sie den Upload, um sie wieder zu ändern.": "These details are locked for this upload. Discard the upload to change them again.",
"Direkt": "Direct",
"DN TSE Cloud": "DN TSE Cloud",
"Do": "Thu",
"downloadUrl missing": "download URL missing",
"E-Mail": "Email",
"E-Mail Tenant-Admin": "Tenant admin email",
"Export per E-Mail senden (optional, Prüfer/Revision)": "Send export by email (optional, auditor/revision)",
"Editieren": "Edit",
"Ein Jahr vor": "One year earlier",
"Ein Jahr zurück": "One year back",
"Ein Monat vor": "One month earlier",
"Ein Monat zurück": "One month back",
"Einloggen": "Sign in",
"Electronic Ledger For Auditability, iNtegrity and Traceability": "Electronic Ledger For Auditability, iNtegrity and Traceability",
"Electronic Ledger for Auditability, Integrity and Traceability": "Electronic Ledger for Auditability, Integrity and Traceability",
"ELeFANT": "ELeFANT",
"ELeFANT Sound abspielen": "Play ELeFANT sound",
"Entfernen": "Remove",
"Entsperren": "Unlock",
"Zurückziehen": "Withdraw",
"Erstellt am": "Created on",
"Event": "Event",
"Export durchführen": "Run export",
"Export fehlgeschlagen.": "Export failed.",
"Export ID": "Export ID",
"exportStatus failed:": "exportStatus failed:",
"Fertig": "Done",
"Filter": "Filter",
"Filter anwenden": "Apply filter",
"Filter...": "Filter...",
"fiskaly Cloud TSE": "fiskaly Cloud TSE",
"fiskaly Cloud TSE ist aktuell nicht unterstützt.": "fiskaly Cloud TSE is currently not supported.",
"Fr": "Fri",
"Benutzerdefiniert": "Custom",
"Belegdaten / Kassendaten": "Receipt data / cash register data",
"Bezeichnung des benutzerdefinierten Typs": "Custom type label",
"„Benutzerdefiniert“ ist nur für Ausnahmefälle vorgesehen, in denen das Artefakt keiner vorhandenen Gruppe zugeordnet werden kann. Wenden Sie sich bei wiederkehrendem Bedarf an Ihren zuständigen Supportkontakt.": "“Custom” should only be used when the artifact cannot be assigned to an existing group. For recurring needs, contact your designated support contact.",
"Freigeben": "Approve",
"Freigegeben": "Approved",
"Für das Unternehmensland gibt es kein aktives Profil.": "There is no active profile for the company country.",
"GB": "GB",
"Gelöschte Einträge zum Filtern anbieten": "Include deleted entries in filters",
"Gelöschte Elemente konnten nicht geladen werden.": "Deleted elements could not be loaded.",
"Gemeldete Eigenschaften": "Reported properties",
"Genehmigen": "Approve",
"Helfer": "Helper",
"Geschäftsbedingungen": "Terms & Conditions",
"Geschäftsbedingungen akzeptieren": "Accept terms and conditions",
"Gesperrt": "Locked",
"Helfer per E-Mail hinzufügen": "Add helper by email",
"Hier einloggen": "Sign in here",
"Ich akzeptiere die": "I accept the",
"Impersonation": "Impersonation",
"Impersonation anfragen": "Request impersonation",
"Impersonation-Anfrage zurückziehen": "Withdraw impersonation request",
"Impersonation-Freigabe zurückziehen": "Withdraw impersonation approval",
"Impersonation beenden": "End impersonation",
"Impersonation-Anfragen": "Impersonation requests",
"Impersonieren": "Impersonate",
"für den EleFANT-Dienst.": "for the EleFANT service.",
"Impersonieren (inaktiv)": "Impersonate (inactive)",
"Impersonisation": "Impersonation",
"Impersonisation verwalten": "Manage impersonation",
"Impressum": "Legal notice",
"In diesem Dialog können Sie Kriterien auswählen, was im Export enthalten sein soll.": "In this dialog you can select the criteria for what should be included in the export.",
"Initialpasswort": "Initial password",
"Initialpasswort muss mindestens 8 Zeichen haben.": "Initial password must have at least 8 characters.",
"invalid exportStatus response": "Invalid exportStatus response",
"invalid file_meta JSON": "Invalid file_meta JSON",
"invalid listExports response": "Invalid listExports response",
"invalid startExport response": "Invalid startExport response",
"invalid TAR export": "Invalid TAR export",
"iShield Key 2 Pro": "iShield Key 2 Pro",
"Kassen/POS verwalten": "Manage cash registers/POS",
"Kategorien": "Categories",
"Kein aktives Länderprofil": "No active country profile",
"Kein gemeinsames wirksames Profil für die gewählte Unternehmensauswahl verfügbar.": "No common valid profile available for the selected companies.",
"Kein Land mit aktivem Profil": "No country with an active profile",
"Kein offener Upload.": "No open upload.",
"Kein offener Upload. Erst Datei hinzufügen.": "No open upload. Add a file first.",
"Keine Anfragen": "No requests",
"Keine API-Keys definiert": "No API keys defined",
"Keine Betriebsstätten": "No sites",
"Keine Betriebsstätten verfügbar": "No sites available",
"Keine Dateien im offenen Upload.": "No files in the open upload.",
"Keine Daten": "No data",
"Keine Einträge vorhanden": "No entries available",
"Keine Unternehmen verfügbar": "No companies available",
"Keine Helfer vorhanden": "No helpers available",
"Keine Kategorien verfügbar": "No categories available",
"Keine Exporte verfügbar": "No exports available",
"Keine Impersonation-Anfragen vorhanden": "No impersonation requests available",
"Keine Passkeys vorhanden": "No passkeys available",
"Keine Nutzer vorhanden": "No users available",
"Keine Organisationen oder Reseller vorhanden": "No organizations or resellers available",
"Keine passende Organisation gefunden": "No matching organization found",
"Keine passenden Anfragen gefunden": "No matching requests found",
"Keine passenden API-Keys gefunden": "No matching API keys found",
"Keine passenden Einträge gefunden": "No matching entries found",
"Keine passenden Helfer gefunden": "No matching helpers found",
"Keine passenden Nutzer gefunden": "No matching users found",
"Keine passenden POS gefunden": "No matching POS found",
"Keine POS": "No POS",
"Keine POS verfügbar": "No POS available",
"Keine Treffer für die gewählten Filter": "No matches for the selected filters",
"Keine Unternehmen vorhanden": "No companies available",
"Klartext Name": "Display name",
"Kundenorganisation anlegen": "Create customer organization",
"Land": "Country",
"Land (ISO-2)": "Country (ISO-2)",
"Letzte Exporte": "Recent exports",
"Weitere Filterung nach Betriebsstätte oder POS ist bei Auswahl mehrerer Unternehmen nicht möglich.": "Further filtering by site or POS is not available when multiple companies are selected.",
"listExports failed:": "listExports failed:",
"Login fehlgeschlagen.": "Login failed.",
"LogMessages.csv column logTime missing": "LogMessages.csv column logTime missing",
"LogMessages.csv header missing": "LogMessages.csv header missing",
"LogMessages.csv inconsistent: no valid logTime rows": "LogMessages.csv inconsistent: no valid logTime rows",
"LogMessages.csv is not valid UTF-8": "LogMessages.csv is not valid UTF-8",
"LogMessages.csv unreadable in TAR export": "LogMessages.csv unreadable in TAR export",
"Link abgelaufen": "Link expired",
"Logout": "Logout",
"Offenen Upload verwerfen und ausloggen?": "Discard the open upload and log out?",
"Offenen Upload verwerfen und Impersonation beenden?": "Discard the open upload and end impersonation?",
"Lädt…": "Loading…",
"Länderkürzel": "Country code",
"Wird angefordert…": "Submitting…",
"Löschen": "Delete",
"MB": "MB",
"Mehrere Dateien können in einen offenen Upload gebündelt werden.": "Multiple files can be bundled into one open upload.",
"Mi": "Wed",
"Mindestens 8 Zeichen": "At least 8 characters",
"Mit Passkey anmelden": "Sign in with passkey",
"Mo": "Mon",
"Name": "Name",
"Name Reseller-Admin (optional)": "Reseller admin name (optional)",
"Name Tenant-Admin": "Tenant admin name",
"Navigation schließen": "Close navigation",
"Nutzerverwaltung öffnen": "Open user management",
"Nutzerverwaltung ausblenden": "Hide user management",
"Vollzugriff": "Full access",
"Vollzugriff öffnen": "Open full access",
"Vollzugriff ausblenden": "Hide full access",
"Organisation bearbeiten": "Edit organization",
"Organisation ausblenden": "Hide organization",
"Navigation öffnen": "Open navigation",
"Neu": "New",
"Neue Organisation anlegen": "Create new organization",
"Neues Passwort": "New password",
"Neues Passwort muss mindestens 8 Zeichen haben.": "New password must have at least 8 characters.",
"Neues Passwort und Wiederholung stimmen nicht überein.": "New password and confirmation do not match.",
"new password too short (min 8)": "New password too short (min 8)",
"Nicht freigegeben": "Not approved",
"Nicht gefunden": "Not found",
"Nur Cloud TSE wird unterstützt.": "Only cloud TSE is supported.",
"Nur Leserechte: API-Keys können nicht bearbeitet werden.": "Read-only access: API keys cannot be edited.",
"Nutzer": "User",
"Nutzer aktualisiert.": "User updated.",
"Nutzer angelegt.": "User created.",
"Nutzeranlage ausblenden": "Hide user creation",
"Nutzer anlegen": "Create user",
"Nutzer editieren": "Edit user",
"Nutzer entsperren": "Unlock user",
"Nutzer gelöscht.": "User deleted.",
"Nutzer löschen": "Delete user",
"Nutzer sperren": "Lock user",
"Nutzer wurde entsperrt.": "User has been unlocked.",
"Nutzer wurde gesperrt.": "User has been locked.",
"Nutzerrechte": "User permissions",
"Nutzerrechte bearbeiten": "Edit user permissions",
"Nutzerverwaltung": "User management",
"Neuen Code erzeugen": "Generate new code",
"Ausgewählte Betriebsstätten": "Selected sites",
"Ausgewählte POS": "Selected POS",
"Ausgewählt": "Selected",
"Bitte mindestens eine Betriebsstätte wählen.": "Please select at least one site.",
"Bitte eine POS wählen.": "Please select a POS.",
"Der vollständige Unternehmensbaum mit allen Betriebsstätten und POS wird exportiert.": "The complete company tree with all sites and POS records is exported.",
"Gesamtes Unternehmen": "Entire company",
"Kein wirksames Profil für das gewählte Unternehmen verfügbar.": "No active profile is available for the selected company.",
"Ohne Betriebsstätten-Auswahl stehen alle POS des Unternehmens zur Auswahl.": "Without site selection, all POS records of the company are available.",
"Ohne POS-Auswahl gilt der Upload für das gesamte Unternehmen oder, falls eine Betriebsstätte ausgewählt ist, für diese Betriebsstätte. Es kann maximal eine POS ausgewählt werden.": "Without a POS selection, the upload applies to the entire company or, if a site is selected, to that site. At most one POS can be selected.",
"Bei Auswahl von Betriebsstätten werden nur deren POS angeboten. Ohne Auswahl werden alle POS des Unternehmens angeboten.": "When sites are selected, only their POS records are offered. Without a site selection, all POS records of the company are offered.",
"Bei POS-Auswahl werden betriebsstättenweite Artefakte der zugehörigen Betriebsstätten sowie unternehmensweite Artefakte berücksichtigt.": "A POS selection includes site-wide artifacts from their parent sites and company-wide artifacts.",
"Unternehmensweite Artefakte werden unabhängig von Betriebsstätten- oder POS-Auswahl immer berücksichtigt.": "Company-wide artifacts are always included, regardless of the selected sites or POS records.",
"Der Export umfasst unternehmensweite Artefakte sowie alle Artefakte der ausgewählten Betriebsstätten und ihrer POS.": "The export includes company-wide artifacts and all artifacts from the selected sites and their POS.",
"Der Export umfasst unternehmensweite Artefakte, betriebsstättenweite Artefakte der zugehörigen Betriebsstätte und Artefakte der ausgewählten POS.": "The export includes company-wide artifacts, site-wide artifacts from the associated site, and artifacts from the selected POS.",
"Umfang": "Scope",
"OK": "OK",
"Organisation": "Organization",
"Organisation aktivieren oder deaktivieren": "Activate or deactivate organization",
"Organisation editieren": "Edit organization",
"Organisation impersonieren": "Impersonate organization",
"Organisation/Kontakt konnten nicht vollständig aktualisiert werden (Backend-Endpoint fehlt). Backend neu starten.": "Organization/contact could not be fully updated (backend endpoint missing). Restart the backend.",
"Organisationsname": "Organization name",
"Organisationsverwaltung": "Organization management",
"Passkey": "Passkey",
"Passkey aktualisiert.": "Passkey updated.",
"Passkey editieren": "Edit passkey",
"Passkey gelöscht.": "Passkey deleted.",
"Passkey hinzufügen": "Add passkey",
"Passkey hinzugefügt.": "Passkey added.",
"Passkey konnte nicht erstellt werden.": "Passkey could not be created.",
"Passwort vergessen?": "Forgot password?",
"Konto aktivieren": "Activate account",
"Passwort setzen": "Set password",
"Konto wird aktiviert…": "Activating account…",
"Prüfe Aktivierungslink…": "Checking activation link…",
"Aktivierungslink fehlt oder ist ungültig.": "Activation link is missing or invalid.",
"Aktivierungslink ist ungültig oder abgelaufen.": "Activation link is invalid or expired.",
"Aktivierungslink ist ungültig oder abgelaufen. Bitte fordern Sie eine neue Einladung bei Ihrem Administrator an.": "Activation link is invalid or expired. Please ask your administrator to send a new invitation.",
"Aktivierungslink konnte nicht geprüft werden.": "Activation link could not be verified.",
"Konto aktiviert. Sie können sich jetzt einloggen.": "Account activated. You can sign in now.",
"Passwort zurückgesetzt. Sie können sich jetzt einloggen.": "Password has been reset. You can sign in now.",
"Passwort zurücksetzen fehlgeschlagen.": "Password reset failed.",
"Passwort vergessen fehlgeschlagen.": "Password reset request failed.",
"Passkey löschen": "Delete passkey",
"Passkey nicht unterstützt": "Passkey not supported",
"Passkey registrieren": "Register passkey",
"Passkey-Anlage ausblenden": "Hide passkey creation",
"Passkey-Anmeldung abgebrochen.": "Passkey sign-in cancelled.",
"Passkey-Anmeldung fehlgeschlagen.": "Passkey sign-in failed.",
"Passkey-Backend nicht verfügbar (WebAuthn-Modul fehlt oder Server nicht neu gestartet).": "Passkey backend not available (WebAuthn module missing or server not restarted).",
"Passkeys ausblenden": "Hide passkeys",
"Passkey-Registrierung abgebrochen.": "Passkey registration cancelled.",
"Passkeys verwalten": "Manage passkeys",
"Passkeys werden von diesem Browser nicht unterstützt.": "Passkeys are not supported by this browser.",
"password too short (min 8)": "Password too short (min 8)",
"Passwort": "Password",
"Passwort anzeigen": "Show password",
"Passwort verbergen": "Hide password",
"Passwort speichern": "Save password",
"Passwort wiederholen": "Repeat password",
"Passwort wurde geändert.": "Password changed.",
"Passwort ändern": "Change password",
"Passwortänderung ausblenden": "Hide password change",
"PATCH": "PATCH",
"Pending": "Pending",
"Platform Admin": "Platform admin",
"POS (optional)": "POS (optional)",
"POS Bezeichnung": "POS label",
"POS Bezeichnung (optional)": "POS label (optional)",
"POS ID": "POS ID",
"POS ist bei Auswahl mehrerer Unternehmen deaktiviert.": "POS is disabled when multiple companies are selected.",
"POS konnte nicht angelegt werden.": "POS could not be created.",
"POS nicht gefunden.": "POS not found.",
"POS Scope": "POS scope",
"POS-Einstellungen konnten nicht gespeichert werden.": "POS settings could not be saved.",
"POS-ID": "POS-ID",
"Die POS-Seriennummer wird aus den gemeldeten Eigenschaften übernommen und nicht manuell bearbeitet.": "The POS serial number is taken from the reported properties and cannot be edited manually.",
"POS Seriennummer": "POS serial number",
"POS-Upload": "POS upload",
"POST": "POST",
"Preview": "Preview",
  "Preview wird nach Klick auf „Filter anwenden“ angezeigt.": "Preview appears after clicking \"Apply filter\".",
"pruefer@beispiel.de": "auditor@example.com",
"Prüfexport": "Audit export",
"Betriebsstättenweit": "Site-wide",
"PUT": "PUT",
"Quelle": "Source",
"Reaktivieren": "Reactivate",
"Rechte": "Permissions",
"Rechte bearbeiten": "Edit permissions",
"Rechte für Neuanlage übernommen.": "Permissions copied for new entry.",
"Rechte gespeichert.": "Permissions saved.",
"Rechtliche Links": "Legal links",
"Reseller": "Reseller",
"Reseller Admin": "Reseller admin",
"Reseller aktivieren oder deaktivieren": "Activate or deactivate reseller",
"Reseller anlegen": "Create reseller",
"Reseller editieren": "Edit reseller",
"Reseller impersonieren": "Impersonate reseller",
"Reseller Name": "Reseller name",
"Reseller Name (optional)": "Reseller name (optional)",
  "reseller@partner.tld": "reseller@partner.tld",
"Sa": "Sat",
"So": "Sun",
"Speichern": "Save",
"Speichert…": "Saving…",
"Sperren": "Lock",
"startExport failed": "startExport failed",
"startExport failed:": "startExport failed:",
"Status": "Status",
"Stop": "Stop",
"Suche (Datei, Typ, Unternehmen, Betriebsstätte, POS)": "Search (file, type, company, site, POS)",
"Suche (Name, E-Mail)": "Search (name, email)",
"Suche (Name, E-Mail, Status)": "Search (name, email, status)",
"Suche (Organisation, Ansprechpartner, E-Mail, Reseller)": "Search (organization, contact person, email, reseller)",
"Suche (POS, Unternehmen, Betriebsstätte, Status)": "Search (POS, company, site, status)",
"Suche (Reseller, Organisation, Ansprechpartner, E-Mail, Status)": "Search (reseller, organization, contact person, email, status)",
"Suche (Unternehmen, Betriebsstätte, POS)": "Search (company, site, POS)",
"Suche (Zeit, Event, Akteur)": "Search (time, event, actor)",
"Suche zurücksetzen": "Reset search",
"E-Mail zurücksetzen": "Reset email",
"Filter zurücksetzen": "Reset filters",
"Swissbit Cloud TSE": "Swissbit Cloud TSE",
"Swissbit HW TSE": "Swissbit HW TSE",
"Tenant Admin": "Tenant admin",
"Tenant User": "Tenant user",
"TSE Seriennummer": "TSE serial number",
"TSE Seriennummer (optional)": "TSE serial number (optional)",
"TSE Seriennummer fehlt.": "TSE serial number missing.",
"TSE Seriennummer ist erforderlich.": "TSE serial number required.",
"TSE Typ": "TSE type",
"TSE-TAR": "TSE TAR",
"TT.MM.JJJJ": "DD.MM.YYYY",
"TT.MM.JJJJ - TT.MM.JJJJ": "DD.MM.YYYY - DD.MM.YYYY",
"Typ": "Type",
"Uhrzeit": "Time",
"Umbenennen": "Rename",
"Unternehmen": "Company",
"Unternehmen anlegen": "Create company",
"Unternehmen neu anlegen": "Create new company",
"Unternehmen verwalten": "Manage companies",
"Unternehmen wählen": "Select company",
"Unternehmensname": "Company name",
"Unternehmensstruktur": "Company structure",
"Unternehmen löschen": "Delete company",
"Unternehmensweit": "Company-wide",
"Einstellungen": "Settings",
"Einstellungen ausblenden": "Hide settings",
"Einstellungen speichern": "Save settings",
"Einstellungen gespeichert.": "Settings saved.",
"Einstellungen konnten nicht gespeichert werden.": "Settings could not be saved.",
"Sprache": "Language",
"Updated": "Updated",
"Upload deaktiviert: Unternehmen mit gültigem Länderprofil auswählen.": "Upload disabled: select a company with a valid country profile.",
"Datei zu groß. Maximal 2 GB pro Datei.": "File too large. Maximum 2 GB per file.",
"Dateien zur Archivierung": "Files pending archiving",
"Upload fehlgeschlagen.": "Upload failed.",
"Upload-Details": "Upload details",
"Upload verwerfen": "Discard upload",
"Upload verwerfen und ausloggen": "Discard upload and log out",
"Upload verwerfen und Impersonation beenden": "Discard upload and end session",
"Upload verwerfen?": "Discard upload?",
"User": "User",
"Verbindlich archivieren": "Archive permanently",
"Verfahrensdoku": "Procedure documentation",
"Verwalten Sie hier alle Ihre Daten rund um die Kasse im Swissbit": "Manage all your cash register data here in Swissbit.",
"Von": "From",
"Vorname Nachname": "First name Last name",
"Warte auf Passkey…": "Waiting for passkey…",
"Sende Reset-Link…": "Sending reset link…",
"Sitzung wird geladen…": "Loading session…",
"Speichern…": "Saving…",
"Zurück zum Login": "Back to login",
"Reset-Link fehlt oder ist ungültig.": "Reset link is missing or invalid.",
"Wenn die E-Mail-Adresse bekannt ist, wurde ein Reset-Link versendet.": "If the email address exists, a reset link has been sent.",
"Web-Upload": "Web upload",
"Widerrufen": "Revoke",
"X-Tenant-Id": "X-Tenant-Id",
"X-User-Role": "X-User-Role",
"z. B. TSE Zertifikat": "e.g. TSE certificate",
"Zeit": "Time",
"Zeitraum": "Period",
  "Zeitraum ungültig: \"Bis\" liegt vor \"Von\".": "Invalid period: \"To\" is before \"From\".",
"Zuklappen": "Collapse",
"Zuletzt verwendet": "Last used",
"Zurücksetzen": "Reset",
"POS löschen": "Delete POS",
"Zurückweisen": "Reject",
"Zusammenfassung": "Summary",
"Zuweisen": "Assign",
"Zuweisung": "Assignment",
"Alle offenen Anfragen auswählen": "Select all open requests",
"Ausgewählte freigeben": "Approve selected",
"Freigabe läuft ...": "Approval in progress ...",
"aktivieren": "activate",
"deaktivieren": "deactivate",
"entsperren": "unlock",
"sperren": "lock",
"Clipboard nicht verfügbar.": "Clipboard is not available.",
"E-Mail ist erforderlich.": "Email is required.",
"Passwort zurücksetzen": "Reset password",
"POS-Seriennummer": "POS serial number",
"Bitte Betriebsstätte wählen oder neu anlegen.": "Please select or create a site.",
"Bitte Unternehmen wählen oder neu anlegen.": "Please select or create a company.",
"Bitte ein bestehendes Unternehmen wählen. Die Neuanlage erfordert das Recht Unternehmen verwalten.": "Please select an existing company. Creating one requires the Manage companies permission.",
"Bitte eine bestehende Betriebsstätte wählen. Die Neuanlage erfordert das Recht Betriebsstätten verwalten.": "Please select an existing site. Creating one requires the Manage sites permission.",
"Prüfe Link…": "Checking link…",
"Reset-Link ist ungültig oder abgelaufen.": "Reset link is invalid or expired.",
"Reset-Link konnte nicht geprüft werden.": "Reset link could not be verified.",
"SHA-256 wird von diesem Browser nicht unterstützt.": "SHA-256 is not supported by this browser.",
"Upload konnte nicht verworfen werden.": "Upload could not be discarded.",
"Upload läuft. Der Dialog ist gesperrt, bis die Datei vollständig übertragen wurde.": "Upload is in progress. This dialog remains locked until the file transfer is complete.",
"Upload läuft…": "Upload in progress…",
"Der aktuelle Upload-Vorgang wird zuerst abgeschlossen. Danach werden verbleibende Dateien und Upload-Auswahlen verworfen. Dies kann nicht rückgängig gemacht werden.": "The current upload operation will finish first. Any remaining files and upload selections will then be discarded. This cannot be undone.",
"Der aktuelle Upload-Vorgang wird abgeschlossen. Die gewählte Aktion wird danach automatisch fortgesetzt.": "The current upload operation is finishing. The selected action will continue automatically afterward.",
"Bitte beachten Sie, dass der Name einer Betriebsstätte nach dem Anlegen derzeit nicht geändert werden kann.": "Please note that a site name currently cannot be changed after creation.",
"Bitte beachten Sie, dass der Name eines Unternehmens nach dem Anlegen derzeit nicht geändert werden kann.": "Please note that a company name currently cannot be changed after creation.",
"Upload wird abgeschlossen…": "Finishing upload…"
}

export const EN_UI_TEMPLATES = {
"archive.total": "Archived artifacts (total {{size}})",
"aria.export.download": "Download export {{id}}",
"aria.company.collapse": "Collapse company {{name}}",
"aria.company.expand": "Expand company {{name}}",
"aria.site.collapse": "Collapse site {{name}}",
"aria.site.expand": "Expand site {{name}}",
  "confirm.delete.company": "Really delete company \"{{label}}\" including all sites and POS?",
  "confirm.delete.api_key": "Really delete the API key for POS \"{{label}}\"?",
"confirm.delete.generic": "Really delete {{label}}?",
  "confirm.delete.passkey": "Really delete passkey \"{{label}}\"?",
  "confirm.delete.pos": "Really delete POS \"{{label}}\"?",
  "confirm.delete.site": "Really delete site \"{{label}}\" including all POS?",
  "confirm.delete.upload_file": "Really delete \"{{label}}\"? This action cannot be undone.",
  "confirm.delete.user": "Really delete user \"{{label}}\"?",
  "confirm.onboarding_code.generate_another": "The currently displayed onboarding code will no longer be shown, but it will remain valid. Make sure you have copied it or entered it in the POS management system first. Generate another onboarding code?",
  "confirm.reject.api_key": "Really reject the API key request for POS \"{{label}}\"?",
  "confirm.toggle.generic": "Really {{action}} {{label}}?",
  "confirm.toggle.user": "Really {{action}} user \"{{label}}\"?",
  "confirm.withdraw.impersonation_access": "Really withdraw impersonation access for \"{{label}}\"? Active impersonation sessions will be ended.",
  "confirm.revoke.impersonation_access": "Really revoke impersonation access for \"{{label}}\"? Active impersonation sessions will be ended.",
  "entity.deleted": "{{name}} (deleted)",
  "entity.deleted_at": "{{name}} (deleted on {{date}})",
"export.category.count": "{{label}} ({{count}})",
"export.requested": "Export requested. Check its status under Recent exports; download it there once it is ready.",
"export.preview.load_failed": "Preview could not be loaded.",
"export.preview.selected_of_total": "Selected results: {{selected}} of {{total}}",
"selection.count": "{{selected}} of {{total}} selected",
"export.tooltip.artifact_group": "Artifact group: {{value}}",
"export.tooltip.company": "Company: {{value}}",
"export.tooltip.id": "Export ID: {{value}}",
"export.tooltip.period": "Period: {{value}}",
"export.tooltip.pos": "POS: {{value}}",
"export.tooltip.site": "Site: {{value}}",
"ingest.tooltip.group_id": "Group ID: {{value}}",
"impersonation.request.pending_count_from_prefix": "You have {{count}} pending impersonation requests from ",
"impersonation.request.pending_from_prefix": "You have a pending impersonation request from ",
"range.from_to": "{{from}} - {{to}}",
"status.value": "Status: {{value}}",
"upload.committed": "Upload accepted. The files will be verified and archived in the background.",
"upload.pos_selected_count": "{{count}} selected",
"api_keys.bulk.result": "{{approved}} API keys approved.",
"api_keys.bulk.result_failed": "{{approved}} approved, {{failed}} could not be approved.",
"pos.api_key.aria": "API key for {{pos}}",
"pos.api_key.setup.belongs_to.prefix": "This API key belongs exclusively to the POS with serial number ",
"pos.api_key.setup.belongs_to.suffix": ". Enter it directly into the POS or in the corresponding settings of your POS management system.",
"upload.transfer.locked.progress": "Upload is in progress ({{percent}}%). This dialog remains locked until the file transfer is complete.",
"upload.transfer.progress": "Upload in progress ({{percent}}%)…"
}
